module.exports = __webpack_public_path__ + "static/polar-logo-button-9b0400abc484a089be78532c28e31f8f.png";